import { ClearEventFormType, EventPanelMetadata } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { CLEAR_EVENT_DEFAULT_FORM_VALUES } from '../../dispositions/constants';
import { useClearEventMutation } from '../../dispositions/hooks/use-clear-event-mutation';
import { useEventMetadataStore } from '../../event-panel/event-panel-form/event-metadata';
import { IntegratedFormProvider } from '../../forms/integrated-form-provider';
import { FR_EVENT_DETAILS_TABS } from '../../fr-event-details-page/constants';
import { useOpenFrEventDetails } from '../../fr-event-details-page/hooks/use-open-fr-event-details';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';
import { useDispositionQuery } from '../../dispositions/hooks/use-disposition-query';

export function FrClearEventContainer(props: { children: React.ReactNode }) {
    const unitAssignment = useUnitAssignment();
    const openFrEventDetails = useOpenFrEventDetails();

    const eventId = unitAssignment?.assignedEvent?.eventId;
    const eventMetadataStore = useEventMetadataStore();
    const { eventId: currentEventId } =
        eventMetadataStore.state.metadata ?? ({} as EventPanelMetadata);

    const clearEventForm = useForm<ClearEventFormType>({
        defaultValues: {
            ...CLEAR_EVENT_DEFAULT_FORM_VALUES,
            eventId,
        },
    });

    const dispositionQuery = useDispositionQuery({ agencyEventId: eventId });
    const clearEventMutation = useClearEventMutation({
        onMutationSuccess: () => {
            openFrEventDetails(currentEventId, FR_EVENT_DETAILS_TABS.NARRATIVE);
        },
    });

    return (
        <IntegratedFormProvider
            query={dispositionQuery}
            mutation={clearEventMutation}
            form={clearEventForm}
        >
            {props.children}
        </IntegratedFormProvider>
    );
}
